var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","loading":_vm.loading,"loading-text":_vm.$t('wgu-attributetable.loadingText'),"headers":_vm.headers,"items":_vm.records,"mobile-breakpoint":"0","page":_vm.page,"footer-props":{
      'items-per-page-options': [],
      'show-first-last-page': true
    },"single-select":"","value":_vm.selectedRow,"item-key":_vm.uniqueRecordKeyName,"items-per-page":_vm.rowsPerPage,"height":_vm.getTableHeight()},on:{"update:page":function($event){_vm.page=$event},"click:row":_vm.onRowClick}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e4eaab","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/attributeTable/AttributeTable.vue
// module id = lqFH
// module chunks = 1